/* eslint-disable @typescript-eslint/no-this-alias */
import { environment } from '../../environments/environment';
import { Location } from '@angular/common';
import { Inject, Injectable, OnDestroy, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from './loader.service';
import { LocalStorageService } from './localStorage.service';
import { CognitoService } from './cognito.service';
declare let pendo: any;
import jwtDecode from "jwt-decode";

@Injectable()
export class SessionService implements OnDestroy {
  cookieName = 'devhub_tkn';
  cookiePath = '/';
  cookieSecure = true;
  cookieSameSite = 'strict';
  cookieExpiresDays = 365;

  constructor(
    private loaderService: LoaderService,
    private location: Location,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private localStorageService: LocalStorageService,
    private cognitoService: CognitoService
  ) {
    // Session handling across multiple tabs
    window.addEventListener('storage', (event) => {
      if (event.key === 'isLoggedIn') {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'false') {
          this.router.navigate(['/']).then(() => {
            window.location.reload();
          });
        }
      }
    });
  }

  jwt: string | null = null;

  ngOnDestroy() {
    window.removeEventListener('storage', () => {}, false);
  }

  getUserInfo(): string | null {
    if (this.isUserSessionCreated()) {
      if (this.jwt) {
        return this.jwt;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getJWT(): string | null {
    return this.jwt;
  }

  logout() {
    if (environment.pendoApiKey && window['pendo'] && window['pendo']['clearSession']) {
      window['pendo'].clearSession();
    }
    this.loaderService.loadingContent.emit(true);
    setTimeout(() => {
      this.jwt = null;
      let userInfo: any = null;
      const userItem = this.localStorageService.getItem('user');
      if (userItem) {
        try {
          userInfo = JSON.parse(userItem);
        } catch (e) {
          userInfo = null;
        }
      }
      this.localStorageService.removeItem('groups');
      this.localStorageService.setItem('isLoggedIn', false);
      this.localStorageService.removeItem('user');
      if (userInfo && userInfo['isDevhubUser']) {
        this.clearUserCookie();
        window.location.href = '/dashboard/logout';
      } else {
        this.cognitoService.logout();
      }
    });
  }

  private clearUserCookie() {
    document.cookie = `${this.cookieName}=; path=${this.cookiePath}; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${
      this.cookieSecure ? 'Secure;' : ''
    } SameSite=${this.cookieSameSite}`;
  }

  createSession() {
    if (!this.isUserSessionCreated()) {
      this.cognitoService.createSession();
      this.jwt = this.cognitoService.jwt;
    }
  }

  isUserSessionCreated() {
    const cookieName = 'devhub_tkn';
    const cookieValue = this.document.cookie
      .split('; ')
      .find((row) => row.startsWith(cookieName))
      ?.split('=')[1];
    if (cookieValue) {
      this.jwt = cookieValue;
      this.localStorageService.setItem('isLoggedIn', true);
      return true;
    }
    return false;
  }
}